import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ButtonRounded from "../../ButtonRounded";
import ModalContainer from "../../ModalContainer";
import Delete from "../../../api/settings/bkvMappings/delete";
import { FormattedMessage } from "react-intl";
import {useModalSimpleStyles} from "../../../common/styles/modalStyles";

const useStyles = useModalSimpleStyles;

const DeleteModal: React.FC<any> = ({ open, onClose, title, id, fetchData }) => {
  const [isError, setIsError] = useState<boolean>(false);
  const classes = useStyles();

  const handleDelete = async () => {
    const response = await Delete(id);
    fetchData();
    if (response && response.success) {
      onClose();
      setIsError(false);
    } else {
      setIsError(true);
    }
  };

  return (
    <ModalContainer
      open={open}
      onClose={onClose}
      title={<FormattedMessage id="settingsView.modalDelete.message" />}
      subtitle={title}
    >
      <div className={classes.modalContent}>
        <Grid container spacing={2} className={classes.btnContainer}>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="outlined"
              onClick={onClose}
              color="default"
            >
              {<FormattedMessage id="settingsView.modal.cancel" />}
            </ButtonRounded>
          </Grid>
          <Grid item xs={6}>
            <ButtonRounded
              fullWidth
              variant="contained"
              color="secondary"
              onClick={handleDelete}
              disabled={isError}
            >
              {<FormattedMessage id="settingsView.modal.delete" />}
            </ButtonRounded>
          </Grid>
        </Grid>
        {isError && (
          <Typography align="center" variant="body2" color="error">
            {<FormattedMessage id="settingsView.modalDelete.failed" />}
            {"Hello"}
            {"."}
          </Typography>
        )}
      </div>
    </ModalContainer>
  );
};

export default DeleteModal;
